module.exports = __webpack_public_path__ + "img/1.3d7f95a6.jpg";